module.exports = __webpack_public_path__ + "img/background.b31ed3ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = AS41
// module chunks = 0